import { useLocation, useNavigate } from 'react-router-dom';

export interface INavigateWithStateParams<T extends object> {
  navigateTo: string;
  state: T;
}

export interface IUseLocationState<T extends object> {
  getLocationState: () => T | undefined;
  navigateWithState: (params: INavigateWithStateParams<T>) => void;
  clearLocationState: () => void;
}

export function useLocationState<T extends object>(): IUseLocationState<T> {
  const { state } = useLocation();
  const navigate = useNavigate();

  const getState = () => {
    return (state as T) || undefined;
  };
  const navigateWithState = (params: INavigateWithStateParams<T>) => {
    return navigate(params.navigateTo, { state: params.state });
  };

  // Some browsers keep history even after refresh -> this manual clear needed
  const clearLocationState = () => {
    window.history.replaceState({}, '');
  };

  return {
    clearLocationState,
    getLocationState: getState,
    navigateWithState,
  };
}
